module.exports = __webpack_public_path__ + "static/img/banner_4.792ecb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_4.png
// module id = A0eh
// module chunks = 1